<template>
  <a-modal title="修改操作次数" :visible="open" @cancel="onClose" @ok="submitForm">
    <a-form-model ref="form" :model="form" :rules="rules" :label-col="labelCol" :wrapper-col="wrapperCol">
      <a-form-model-item label="总次数" prop="totalCount">
        <a-input-number v-model="form.totalCount" :min="0" style="width: 200px" />
      </a-form-model-item>
      <a-form-model-item label="已用次数" prop="usedCount">
        <a-input-number v-model="form.usedCount" :min="0" style="width: 200px" />
      </a-form-model-item>
      <a-form-model-item label="备注" prop="remark">
        <a-textarea v-model="form.remark" :rows="2" />
      </a-form-model-item>
    </a-form-model>
  </a-modal>
</template>

<script>
import { updateOperationCount } from '@/api/cloudplant/operationCount'

export default {
  name: 'EditForm',
  data() {
    return {
      labelCol: { span: 6 }, wrapperCol: { span: 16 }, open: false, submitLoading: false,
      form: { id: null, totalCount: 0, usedCount: 0, remark: null },
      rules: { totalCount: [{ required: true, message: '总次数不能为空', trigger: 'blur' }] }
    }
  },
  methods: {
    onClose() { this.open = false; this.reset() },
    reset() { this.form = { id: null, totalCount: 0, usedCount: 0, remark: null } },
    handleEdit(row) { this.reset(); this.form = { id: row.id, totalCount: row.totalCount, usedCount: row.usedCount, remark: row.remark }; this.open = true },
    submitForm() {
      this.$refs.form.validate(valid => {
        if (valid) {
          updateOperationCount(this.form).then(() => { this.$message.success('修改成功'); this.open = false; this.$emit('ok') })
        }
      })
    }
  }
}
</script>
